import { render } from "./encomenda.vue?vue&type=template&id=2afe10e2"
import script from "./encomenda.vue?vue&type=script&lang=js"
export * from "./encomenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__